import NewsBlockItem from "components/News/NewsBlockItem";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "./NewsPagePaginated.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useNewsPageContext } from "context/NewsPageContext";

const Items = ({ currentItems }) => {
  return (
    <div className="news-items-wrapper">
      {currentItems &&
        currentItems.map((item, index) => (
          <NewsBlockItem item={item} key={index} />
        ))}
    </div>
  );
};

const PaginatedItems = ({ itemsPerPage, items }) => {
  const { setSelectedPage, selectedPage, setOffset, offset } =
    useNewsPageContext();
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    const endOffset = offset + itemsPerPage;
    setCurrentItems(items.slice(offset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [offset, itemsPerPage, items, selectedPage]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setOffset(newOffset);
    setSelectedPage(event.selected);
    window.scrollTo(0, 0)
  };

  return (
    <>
      <Items currentItems={currentItems} />{" "}
      <ReactPaginate
        nextLabel={<FaArrowRight />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel={<FaArrowLeft />}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={selectedPage}
      />
    </>
  );
};

export default PaginatedItems;
